import actions from './actions';


const { 
    ABOUT_INFO_DATA_BEGIN, ABOUT_INFO_DATA_SUCCESS, ABOUT_INFO_DATA_ERR, 
    ABOUT_INFO_PPT_DETAILS_DATA_BEGIN, ABOUT_INFO_PPT_DETAILS_DATA_SUCCESS, ABOUT_INFO_PPT_DETAILS_DATA_ERR, ABOUT_INFO_PPT_DETAILS_DATA_RESET,
    ABOUT_INFO_PPT_LIST_DATA_BEGIN, ABOUT_INFO_PPT_LIST_DATA_SUCCESS, ABOUT_INFO_PPT_LIST_DATA_ERR, ABOUT_INFO_PPT_LIST_DATA_RESET,
    ABOUT_CUSTOMER_INFO_DATA_BEGIN, ABOUT_CUSTOMER_INFO_DATA_SUCCESS, ABOUT_CUSTOMER_INFO_DATA_ERR, ABOUT_CUSTOMER_INFO_DATA_RESET,
    ABOUT_FBO_DETAILS_DATA_BEGIN, ABOUT_FBO_DETAILS_DATA_SUCCESS, ABOUT_FBO_DETAILS_DATA_ERR, ABOUT_FBO_DETAILS_DATA_RESET,
    SUBMIT_PPT_INFO_DATA_BEGIN,SUBMIT_PPT_INFO_DATA_SUCCESS, SUBMIT_PPT_INFO_DATA_ERR, SUBMIT_PPT_INFO_DATA_RESET,
    ABOUT_HISTORY_DETAILS_BEGIN,ABOUT_HISTORY_DETAILS_SUCCESS, ABOUT_HISTORY_DETAILS_ERR,
    ABOUT_GET_EXCHANGE_DATA_BEGIN, ABOUT_GET_EXCHANGE_DATA_SUCCESS, ABOUT_GET_EXCHANGE_DATA_ERR, ABOUT_GET_EXCHANGE_DATA_RESET,
    SUBMIT_MISSING_PPT_INFO_DATA_BEGIN,SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS, SUBMIT_MISSING_PPT_INFO_DATA_ERR, SUBMIT_MISSING_PPT_INFO_DATA_RESET,
    ABOUT_START_TOKEN_BEGIN, ABOUT_START_TOKEN_SUCCESS, ABOUT_START_TOKEN_ERR, ABOUT_START_TOKEN_RESET,
    ABOUT_EXCHNAGE_PRICE_BEGIN,ABOUT_EXCHNAGE_PRICE_SUCCESS,ABOUT_EXCHNAGE_PRICE_ERR,ABOUT_EXCHNAGE_PRICE_RESET,
    ABOUT_ITEM_SEARCH_BEGIN, ABOUT_ITEM_SEARCH_SUCCESS, ABOUT_ITEM_SEARCH_ERR, ABOUT_ITEM_SEARCH_RESET,
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

// About Information Data Reducers
export const aboutInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

// About PPT List Data Reducers
export const aboutInfoPPTListDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_INFO_PPT_LIST_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_INFO_PPT_LIST_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_INFO_PPT_LIST_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_INFO_PPT_LIST_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
};

// About Details Data Reducers
export const aboutInfoPPTDetailsDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_INFO_PPT_DETAILS_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_INFO_PPT_DETAILS_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_INFO_PPT_DETAILS_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_INFO_PPT_DETAILS_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
};

// About Customer Info
export const aboutCustomerInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_CUSTOMER_INFO_DATA_BEGIN:
            return {
                ...state,
                loading: true,
            };
        case ABOUT_CUSTOMER_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_CUSTOMER_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_CUSTOMER_INFO_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const submitaAboutFBODataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_FBO_DETAILS_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_FBO_DETAILS_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_FBO_DETAILS_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_FBO_DETAILS_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}


// About PP Info Submit Date Reducers
export const submitAboutPPTInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SUBMIT_PPT_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case SUBMIT_PPT_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case SUBMIT_PPT_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case SUBMIT_PPT_INFO_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}



export const getExchangeDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_GET_EXCHANGE_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_GET_EXCHANGE_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_GET_EXCHANGE_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_GET_EXCHANGE_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const submitAboutMissingPPTInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SUBMIT_MISSING_PPT_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case SUBMIT_MISSING_PPT_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case SUBMIT_MISSING_PPT_INFO_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}


export const AboutHistoryDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_HISTORY_DETAILS_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_HISTORY_DETAILS_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_HISTORY_DETAILS_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        default:
            return state;
    }
}

export const AboutViewDetailsReducer = (state=initialStateArray,action)=>{
    const { type, data, err } = action
    switch (type) {
      case "ABOUT_VIEW_DETAILS_BEGIN":
        return{
          ...state,
          loading:true
        };
        case "ABOUT_VIEW_DETAILS_SUCCESS":
          return{
            ...state,
            data,
            error:null,
            loading:false
          }
        case "ABOUT_VIEW-DETAILS_ERR":
          return{
            ...state,
            error:err,
            data:null,
            loading:false,
          }
        default:
          return state
    }
}


export const AboutFBOHistoryDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case "ABOUT_FBO_HISTORY_DETAILS_BEGIN":
            return {
                ...initialStateArray,
                loading: true,
            };
        case "ABOUT_FBO_HISTORY_DETAILS_SUCCESS":
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case "ABOUT_FBO_HISTORY_DETAILS_ERR":
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        default:
            return state;
    }
}

export const AboutFBOViewDetailsReducer = (state=initialStateArray,action)=>{
    const { type, data, err } = action
    switch (type) {
      case "ABOUT_FBO_VIEW_DETAILS_BEGIN":
        return{
          ...state,
          loading:true
        };
        case "ABOUT_FBO_VIEW_DETAILS_SUCCESS":
          return{
            ...state,
            data,
            error:null,
            loading:false
          }
        case "ABOUT_FBO_VIEW-DETAILS_ERR":
          return{
            ...state,
            error:err,
            data:null,
            loading:false,
          }
        default:
          return state
    }
}

export const postStartTokenDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_START_TOKEN_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_START_TOKEN_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_START_TOKEN_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_START_TOKEN_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const postExchnagePricenDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_EXCHNAGE_PRICE_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_EXCHNAGE_PRICE_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_EXCHNAGE_PRICE_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_EXCHNAGE_PRICE_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const aboutItemSearchDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case ABOUT_ITEM_SEARCH_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case ABOUT_ITEM_SEARCH_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case ABOUT_ITEM_SEARCH_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case ABOUT_ITEM_SEARCH_RESET:
            return initialStateArray;

        default:
            return state;
    }
}
